import { AloftPrice, EditablePropertyData, ManualAdjustments } from '@aloft/toolkit-shared';
import { createSelector } from '@reduxjs/toolkit';

import { selectIsInspectifyOrder } from '../orderSelectors.ts';
import { selectEditablePropertyDataEntities } from './editablePropertyDataSelectors.ts';

export const selectManualAdjustmentsEntities = createSelector(
  [selectEditablePropertyDataEntities, selectIsInspectifyOrder],
  (editablePropertyDataEntities, isInspectifyOrder) =>
    Object.fromEntries(
      Object.entries(editablePropertyDataEntities)
        .filter(([id, _editableData]) => id !== 'subject' && id !== 'subjectArv')
        .map(([id, editableData]) => [
          id,
          {
            id,
            ...(editableData as EditablePropertyData).manualAdjustments,
            ...(isInspectifyOrder
              ? { concessions: AloftPrice.zero, termsOfSale: AloftPrice.zero }
              : {}),
          },
        ]),
    ) as Record<string, { id: string } & ManualAdjustments>,
);

export const selectManualAdjustmentsById = createSelector(
  [selectManualAdjustmentsEntities, (_state, id: string) => id],
  (manualAdjustmentsEntities, id) => manualAdjustmentsEntities[id],
);

export const selectAllManualAdjustments = createSelector(
  [selectManualAdjustmentsEntities],
  (manualAdjustmentsEntities) => Object.values(manualAdjustmentsEntities),
);
